import axios from '@/api/config';

const advertising = {
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/advertisement/pageList`, data);
  },
  addAdvertisement (data) {
    return axios.post(`${process.env.BASE_URL}/advertisement/addAdvertisement`, data);
  },
  updateAdvertisement (data) {
    return axios.put(`${process.env.BASE_URL}/advertisement/updateAdvertisement`, data);
  },
  deleteAdvertisement (data) {
    return axios.post(`${process.env.BASE_URL}/advertisement/deleteTemplate`, data);
  },

}

export default advertising;



// WEBPACK FOOTER //
// ./src/api/advertising.js